<template>
    <div class="map-item__controls">
        <img
            :src="isVisible ? '/images/map/visible.svg' : '/images/map/hidden.svg'"
            alt="Toggle visibility"
            @click="$emit('set-visibility')"
        />
        <img
            src="/images/map/location.svg"
            alt="Go to location"
            @click="$emit('locate-item', mapItem)"
        />

        <more-options @clear="clear"></more-options>
    </div>
</template>

<script>
import MoreOptions from './MoreOptions.vue'

export default {
    components: {
        MoreOptions,
    },

    props: {
        isVisible: Boolean,
        mapItem: {
            type: [Object, Array],
            required: true,
        },
        clearMapObject: {
            type: Function,
            required: true,
        },
    },

    methods: {
        clear() {
            this.clearMapObject(this.mapItem)
        },
    },
}
</script>
